import axios from 'axios';

// Request deduplication map for fallback API
const pendingFallbackRequests = new Map();

// Fallback API service that uses the same proxy to avoid CORS issues
const fallbackApi = axios.create({
  baseURL: '/api', // Use the same proxy as main API
  timeout: 8000, // Even shorter timeout for fallback to fail fast
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for fallback API
fallbackApi.interceptors.request.use(
  (config) => {
    // Create a unique key for this request (for cleanup purposes only)
    const requestKey = `${config.method?.toUpperCase()}_${config.url}`;
    
    // Add this request to pending requests with timestamp (for cleanup only)
    pendingFallbackRequests.set(requestKey, { timestamp: Date.now() });
    
    console.log(`Fallback API Request: ${config.method?.toUpperCase()} ${config.url}`);
    
    // Store the request key for cleanup
    config.requestKey = requestKey;
    
    return config;
  },
  (error) => {
    console.error('Fallback API Request Interceptor Error:', error);
    return Promise.reject(error);
  }
);

// Log fallback responses and cleanup
fallbackApi.interceptors.response.use(
  (response) => {
    // Clean up pending request
    if (response.config.requestKey) {
      pendingFallbackRequests.delete(response.config.requestKey);
    }
    
    console.log(`Fallback API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    // Clean up pending request on error
    if (error.config?.requestKey) {
      pendingFallbackRequests.delete(error.config.requestKey);
    }
    
    console.error(`Fallback API Error: ${error.code || 'UNKNOWN'} - ${error.message}`);
    return Promise.reject(error);
  }
);

export default fallbackApi;
